export default __webpack_public_path__ + "static/media/Wrap of the Oxmal.3e7ed107.jpg";